import { editor, MarkerSeverity } from 'monaco-editor-core';
import {
  SqliteModelParsedSchema,
} from './interface';

export class SqliteValidator {
  private static instance: SqliteValidator;

  public static getInstance() {
    if (!this.instance) {
      this.instance = new SqliteValidator();
    }

    return this.instance;
  }

  private constructor() {}

  public async doValidate(ast, options: SqliteModelParsedSchema, markers: editor.IMarkerData[]) {
    //TODO to implement on AST parsing
  }}
